import React, { useEffect, useState } from "react";

import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Textarea,
  Flex,
  Box,
  VStack,
  Icon,
  InputGroup,
  InputLeftElement,
  useToast,
} from "@chakra-ui/react";

import { FiHash, FiEdit, FiFileText, FiTag } from "react-icons/fi";

import TeamSelect from "../../../../../components/select/TeamSelect";
import client from "../../../../../helpers/Client";
import SaveButton from "../../../../../components/buttons/SaveButton";
import TaskTypeSelect from "../../../../../shared/components/IssueTypeSelect";
export default function BulkCreateTaskModal({
  ticketURL,
  resellerID,
  ticketRevalidator,
  state,
}) {
  const toast = useToast();
  
  // Modern color mode values
  const bgColor = 'white';
  const borderColor = 'gray.200';
  const inputBg = 'gray.50';
  const inputFocusBg = 'white';
  const textColor = 'gray.800';
  const placeholderColor = 'gray.500';
  
  const [dnumStart, setDnumStart] = useState(0);
  const [dnumEnd, setDnumEnd] = useState(0);
  const [title, setTitle] = useState(null);
  const [body, setBody] = useState(null);
  const [kind, setKind] = useState(null);
  const [teamURL, setTeamURL] = useState(null);
  const [buttonLocked, setButtonLocked] = useState(false);
  const [errorData, setErrorData] = useState({});

  const handleCreate = () => {
    setButtonLocked(true);
    setErrorData({});
    
    client
      .post("/tasks/bulk_create/", {
        title,
        body,
        kind,
        ticket: ticketURL,
        dnum_start: dnumStart,
        dnum_end: dnumEnd,
        assigned_to: teamURL,
      })
      .then(() => {
        toast({
          title: "Başarılı!",
          description: "Çoklu görevler başarıyla oluşturuldu.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        setErrorData({});
        ticketRevalidator.revalidate();
        state.onClose();
      })
      .catch((error) => {
        toast({
          title: "Hata!",
          description: "Görevler oluşturulurken bir hata oluştu.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        setErrorData(error.response.data);
      })
      .finally(() => {
        setButtonLocked(false);
      });
  };

  // useEffect(() => console.log(errorData), [errorData])

  const handleClose = () => {
    setErrorData({});
    state.onClose();
  };

  return (
    <Modal isOpen={state.isOpen} onClose={state.onClose} size="lg">
      <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
      <ModalContent
        bg={bgColor}
        borderRadius="20px"
        border="1px solid"
        borderColor={borderColor}
        boxShadow="xl"
        mx={4}
      >
        <ModalHeader
          bgGradient="linear(to-r, blue.400, purple.500)"
          bgClip="text"
          fontSize="xl"
          fontWeight="bold"
          borderTopRadius="20px"
          pb={2}
        >
          Çoklu Görev Oluştur
        </ModalHeader>
        <ModalCloseButton
          onClick={handleClose}
          color={textColor}
          _hover={{ bg: 'gray.100' }}
          borderRadius="full"
        />
        <ModalBody p={6}>
          <VStack spacing={4} align="stretch">
            <Flex gap={4}>
              <FormControl isRequired isInvalid={errorData?.dnum_start}>
                <FormLabel color={textColor} fontWeight="semibold">İlk Kapı Numarası</FormLabel>
                <InputGroup>
                  <InputLeftElement pointerEvents="none">
                    <Icon as={FiHash} color={placeholderColor} />
                  </InputLeftElement>
                  <Input
                    type="number"
                    bg={inputBg}
                    border="1px solid"
                    borderColor={borderColor}
                    color={textColor}
                    _hover={{ borderColor: 'blue.300' }}
                    _focus={{
                      borderColor: 'blue.500',
                      bg: inputFocusBg,
                      boxShadow: '0 0 0 1px var(--chakra-colors-blue-500)'
                    }}
                    borderRadius="12px"
                    h="48px"
                    onChange={(e) => setDnumStart(e.target.value)}
                  />
                </InputGroup>
                {errorData.dnum_start &&
                  errorData.dnum_start.map((e) => (
                    <FormErrorMessage key={e}>{e}</FormErrorMessage>
                  ))}
              </FormControl>
              <FormControl isRequired isInvalid={errorData?.dnum_end}>
                <FormLabel color={textColor} fontWeight="semibold">Son Kapı Numarası</FormLabel>
                <InputGroup>
                  <InputLeftElement pointerEvents="none">
                    <Icon as={FiHash} color={placeholderColor} />
                  </InputLeftElement>
                  <Input
                    type="number"
                    bg={inputBg}
                    border="1px solid"
                    borderColor={borderColor}
                    color={textColor}
                    _hover={{ borderColor: 'blue.300' }}
                    _focus={{
                      borderColor: 'blue.500',
                      bg: inputFocusBg,
                      boxShadow: '0 0 0 1px var(--chakra-colors-blue-500)'
                    }}
                    borderRadius="12px"
                    h="48px"
                    onChange={(e) => setDnumEnd(e.target.value)}
                  />
                </InputGroup>
                {errorData.dnum_end &&
                  errorData.dnum_end.map((e) => (
                    <FormErrorMessage key={e}>{e}</FormErrorMessage>
              ))}
             </FormControl>
             </Flex>
             
             <FormControl isRequired isInvalid={errorData?.title}>
               <FormLabel color={textColor} fontWeight="semibold">Başlık</FormLabel>
               <InputGroup>
                 <InputLeftElement pointerEvents="none">
                   <Icon as={FiEdit} color={placeholderColor} />
                 </InputLeftElement>
                 <Input
                   type="text"
                   bg={inputBg}
                   border="1px solid"
                   borderColor={borderColor}
                   color={textColor}
                   _hover={{ borderColor: 'blue.300' }}
                   _focus={{
                     borderColor: 'blue.500',
                     bg: inputFocusBg,
                     boxShadow: '0 0 0 1px var(--chakra-colors-blue-500)'
                   }}
                   borderRadius="12px"
                   h="48px"
                   onChange={(e) => setTitle(e.target.value)}
                 />
               </InputGroup>
               {errorData.title &&
                 errorData.title.map((e) => (
                   <FormErrorMessage key={e}>{e}</FormErrorMessage>
                 ))}
             </FormControl>
             
             <FormControl isInvalid={errorData.body}>
               <FormLabel color={textColor} fontWeight="semibold">Açıklama</FormLabel>
               <InputGroup>
                 <InputLeftElement pointerEvents="none" alignItems="flex-start" pt={3}>
                   <Icon as={FiFileText} color={placeholderColor} />
                 </InputLeftElement>
                 <Textarea
                   bg={inputBg}
                   border="1px solid"
                   borderColor={borderColor}
                   color={textColor}
                   _hover={{ borderColor: 'blue.300' }}
                   _focus={{
                     borderColor: 'blue.500',
                     bg: inputFocusBg,
                     boxShadow: '0 0 0 1px var(--chakra-colors-blue-500)'
                   }}
                   borderRadius="12px"
                   minH="100px"
                   pl="40px"
                   onChange={(e) => setBody(e.target.value)}
                 />
               </InputGroup>
               {errorData.body &&
                 errorData.body.map((e) => (
                   <FormErrorMessage key={e}>{e}</FormErrorMessage>
                 ))}
             </FormControl>
             
             <FormControl isInvalid={errorData.kind}>
               <FormLabel color={textColor} fontWeight="semibold">Tip</FormLabel>
               <Box position="relative">
                 <Icon
                   as={FiTag}
                   position="absolute"
                   left={3}
                   top="50%"
                   transform="translateY(-50%)"
                   color={placeholderColor}
                   zIndex={2}
                 />
                 <TaskTypeSelect
                   selectedOption={kind}
                   setSelectedOption={setKind}
                   bg={inputBg}
                   border="1px solid"
                   borderColor={borderColor}
                   color={textColor}
                   _hover={{ borderColor: 'blue.300' }}
                   _focus={{
                     borderColor: 'blue.500',
                     bg: inputFocusBg,
                     boxShadow: '0 0 0 1px var(--chakra-colors-blue-500)'
                   }}
                   borderRadius="12px"
                   h="48px"
                   pl="40px"
                 />
               </Box>
               {errorData.kind &&
                 errorData.kind.map((e) => (
                   <FormErrorMessage key={e}>{e}</FormErrorMessage>
               ))}
             </FormControl>
             <TeamSelect
               {...{
                 resellerID,
                 teamURL,
                 setSelectedTeamURL: setTeamURL,
                 errorData,
               }}
             />

             {errorData.non_field_errors &&
               errorData.non_field_errors.map((e) => (
                 <Box
                   bg="red.500"
                   color="white"
                   p={3}
                   borderRadius="12px"
                   fontWeight="medium"
                   key={e}
                 >
                   {e}
                 </Box>
               ))}
           </VStack>
         </ModalBody>
         <ModalFooter
           borderTop="1px solid"
           borderColor={borderColor}
           p={6}
           borderBottomRadius="20px"
         >
           <Button
             variant="outline"
             mr={3}
             onClick={handleClose}
             borderColor={borderColor}
             color={textColor}
             _hover={{
               bg: 'gray.50',
               transform: 'translateY(-1px)'
             }}
             size="lg"
             borderRadius="12px"
           >
             Vazgeç
           </Button>
           <Button
             bgGradient={'linear(to-r, blue.400, blue.600)'}
             color="white"
             _hover={{
               bgGradient: 'linear(to-r, blue.500, blue.700)',
               transform: 'translateY(-2px)',
               boxShadow: 'lg'
             }}
             _active={{
               transform: 'translateY(0px)',
               boxShadow: 'md'
             }}
             borderRadius="12px"
             fontWeight="semibold"
             size="lg"
             h="48px"
             transition="all 0.2s"
             isDisabled={title === null || buttonLocked || title?.length === 0}
             isLoading={buttonLocked}
             loadingText="Kaydediliyor..."
             onClick={handleCreate}
           >
             Kaydet
           </Button>
         </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
